module.exports = __webpack_public_path__ + "img/arh_11.83db25ae.png";